import { Component, ViewEncapsulation, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TranslateModule } from '@ngx-translate/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

import { LoadingSpinnerComponent } from '../../utils/loading-spinner.component';
import { simpleTransitions } from '../../../shared/animations/simple-transitions';
import { LoginService } from '../../../services/login.service';

@Component({
	selector: 'copo-no-visibility-access',
	templateUrl: './no-visibility-access.component.html',
	animations: simpleTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	styleUrls: ['./no-visibility-access.component.css'],
	standalone: true,
	// eslint-disable-next-line deprecation/deprecation
	imports: [NgIf, CdkScrollable, TranslateModule, MatLegacyButtonModule, LoadingSpinnerComponent]
})
export class NoVisibilityAccessComponent {
	@HostBinding('class.mat-typography') matTypography = true;
	@HostBinding('class.full-height') fullHeight = true;

	state: string | undefined;
	responseType: string | undefined;
	redirectUri: string | undefined;
	clientId: string | undefined;
	codeChallenge: string | undefined;
	codeChallengeMethod: string | undefined;
	submitting = false;
	submittingTimeout: number | undefined;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly loginService: LoginService
	) {
		const params = <Record<string, string | undefined>> this.route.snapshot.queryParams;
		this.state = params['state'];
		this.responseType = params['response_type'];
		this.redirectUri = params['redirect_uri'];
		this.clientId = params['client_id'];
		this.codeChallenge = params['code_challenge'];
		this.codeChallengeMethod = params['code_challenge_method'];
		if (this.clientId) {
			return;
		}
		this.clientId = '7U2EyJ8Xn5UvRPWA';
		this.responseType = 'code';
		this.state = '/';
	}

	logoutUrl() {
		const logoutUrl = new URL('/rest/auth/logout', location.origin);
		const logoutParams = logoutUrl.searchParams;
		const callbackUrl = this.getAuthRequestURL();
		logoutParams.set('callback', String(callbackUrl));
		return logoutUrl;
	}

	getAuthRequestURL() {
		return this.loginService
			.createUrl(
				'/rest/auth/oauth2',
				this.state,
				this.responseType,
				this.redirectUri,
				this.clientId,
				this.codeChallenge,
				this.codeChallengeMethod
			);
	}

	logout() {
		this.submitting = true;
		location.replace(this.logoutUrl().toString());
		this.reEnableAfter(30_000);
	}

	private reEnableAfter(time: number) {
		this.submittingTimeout = setTimeout(
			() => {
				this.submittingTimeout = undefined;
				this.submitting = false;
			},
			time
		);
	}
}
